import {Autocomplete, TextField} from "@mui/material";
import React, {useMemo} from "react";


export const CustomAutocomplete = ({items, value, onUpdate, label, ...props}) => {

  const selectedValue = useMemo(() => {
    if (value?.id) {
      return value;
    }
    return items.find((item) => item.id === value) || null // Ensure correct value matching
  }, [value, items])

  return (
    <Autocomplete
      size={"small"}
      renderInput={(params) => <TextField {...params} label={label} />}
      options={items}
      value={selectedValue}
      getOptionLabel={(option) => option.name}
      onChange={(event, newValue) => {
        onUpdate(newValue);
      }}
      {...props}
    />
  )
}
